module.exports = __webpack_public_path__ + "img/arrowLeft.ba75f286.svg";